module.exports = __webpack_public_path__ + "static/media/lightbrickred.112b229b.png";